// extracted by mini-css-extract-plugin
export default {"input":"Input_input__RV6ej","removeAdditionalPadding":"Input_removeAdditionalPadding__iIAms","isLocked":"Input_isLocked__670nZ"};